/**
 * Determines if the browser is in Google Classroom
 * based on URL search parameters.
 */
export function isClassroomAssignment(
  searchParams: URLSearchParams | null,
): boolean {
  if (!searchParams) return false;
  const itemId = searchParams.get("itemId");
  const itemType = searchParams.get("itemType");
  return itemType === "courseWork" && itemId !== null;
}
